<script>
import { HomeIcon, UserIcon, KeyIcon } from "vue-feather-icons";
import config from "@/config.json";
import axios from 'axios';
import {post} from "@/assets/js/utils";

/**
 * Auth-login component
 */
export default {
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      showTip: false,
      isSuccess: false,
      message: "",
    };
  },
  methods: {
    async login() {
      this.loading = true;
      if (this.email.trim() === "" || this.password.trim() === "") {
        return;
      }
      const {email, password} = this;
      const params = {email, password};
      const ak = localStorage.getItem("access_key");
      if (ak) {
        params['access_key'] = ak;
      }

      try {
        const data = await post(`${config.api.login}`, params);
        console.log(data);
        if (data.errno === 0) {
          localStorage.setItem("access_key", data['access_key']);
          localStorage.setItem("access_token", data['access_token']);
          this.showTip = true;
          this.isSuccess = true;
          this.message = this.$t('login.login_success');
          setTimeout(() => {
            this.$router.push('/profile');
          }, 1000);
        } else {
          this.loading = false;
          this.showTip = true;
          this.isSuccess = false;
          this.message = data.info
        }
      } catch (e) {
        this.loading = false;
        this.showTip = true;
        this.isSuccess = false;
        this.message = e.toString();
      }
    }
  },
  components: {
    HomeIcon,
    UserIcon,
    KeyIcon,
  },
};
</script>

<template>
  <div>
    <div class="back-to-home rounded d-none d-sm-block">
      <router-link to="/" class="btn btn-icon btn-soft-primary">
        <home-icon class="icons"></home-icon>
      </router-link>
    </div>

    <!-- Hero Start -->
    <section class="bg-home d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-6">
            <div class="mr-lg-5">
              <img loading="eager" fetchpriority="high"
                src="/images/user/login.svg"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </div>
          </div>
          <div class="col-lg-5 col-md-6">
            <div class="card login-page bg-white shadow rounded border-0">
              <div class="card-body">
                <h2 class="h4 card-title text-center">{{$t('login.title')}}</h2>
                <form class="login-form mt-4" @submit.prevent="login">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label>{{$t('login.email')}} <span class="text-danger">*</span></label >
                        <div class="position-relative">
                          <user-icon class="fea icon-sm icons"></user-icon>
                          <input
                            type="email"
                            v-model="email"
                            class="form-control pl-5"
                            @focus="showTip=false"
                            :placeholder="$t('login.emailTip')"
                            name="email"
                            required=""
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <div class="form-group">
                        <label>{{$t('login.password')}}<span class="text-danger">*</span></label >
                        <div class="position-relative">
                          <key-icon class="fea icon-sm icons"></key-icon>
                          <input
                            type="password"
                            v-model="password"
                            @focus="showTip=false"
                            class="form-control pl-5"
                            :placeholder="$t('login.passwordTip')"
                            required=""
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <div class="d-flex justify-content-between">
                        <div class="form-group">
                          <div class="custom-control custom-checkbox"> </div>
                        </div>
                        <p class="forgot-pass mb-0">
                          <router-link
                            to="/auth-re-password"
                            class="text-dark font-weight-bold">{{$t('login.forgot_pass')}}</router-link>
                        </p>
                      </div>
                    </div>
                    <div class="col-lg-12 mb-0">
                      <div v-if="showTip" class="alert " :class="{'alert-danger': !isSuccess, 'alert-success': isSuccess}" role="alert">
                        <i v-if="isSuccess" class="uil uil-check"></i>
                        <i v-if="!isSuccess" class="uil uil-times"></i>
                        {{message}}
                      </div>
                      <button :disabled="loading" class="btn btn-primary btn-block">{{$t('login.title')}}</button>
                    </div>
                    <!--end col-->
                    <div class="col-12 text-center">
                      <p class="mb-0 mt-3">
                        <small class="text-dark mr-2" >{{$t('login.no_account')}}</small >
                        <router-link to="/auth-signup" class="text-primary font-weight-bold" >{{$t('login.signup')}}</router-link >
                      </p>
                    </div>
                  </div>
                </form>

              </div>
            </div>
            <!---->
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->
  </div>
</template>
